import {objectDifference, difference, reject, identity, mapValues, includes, createReducer, combineReducers} from 'helpers';
import * as encoders from './encode';

const changes = createReducer([], {
  APP_DATA_CHANGED: (state, action) => {
    const encoder = encoders[action.modelType] || identity;
    const change = {
      action: action.action,
      attempts: 0,
      type: action.modelType,
      timestamp: action.timestamp_ms,
    }

    switch (action.action) {
      case 'create':
        change.payload = {
          ...encoder(action.model),
          serverId: action.id,
        };
        break;

      case 'update':
        const payload = objectDifference(encoder(action.now), encoder(action.prev));
        change.payload = {
          ...payload,
          lastModifiedDates: mapValues(payload, () => action.timestamp_ms),
          serverId: action.id,
        }
        break;

      case 'delete':
        //remove processed create change with the same id
        state = reject(state, { action: 'create', type: action.modelType, processed: true, payload: { serverId: action.id } })
        change.payload = { serverId: action.id };
        break;
    }

    return [
      ...state,
      change,
    ];
  },

  APP_SETTINGS_CHANGED: (state, action) => [
    ...state,
    {
      action: action.action,
      attempts: 0,
      timestamp: action.timestamp_ms,
      payload: action.payload,
    },
  ],

  APP_CLARITY_CHANGED:  (state, { change }) => [ ...reject(state, { action: change.action }), change ],

  APP_IDENTITY_CHANGED: (state, { change }) => [ ...reject(state, { action: change.action }), change ],

  SERVER_QUERY_COMPLETED: (state, action) => {
    return state.map(change => {
      if (includes(action.cancelled, change)) {
        return false;
      } else if (includes(action.changes, change)) {
        change = {
          ...change,
          processed: !action.error,
        }
        if (action.error && !action.error.disconnected) {
          change.attempts++;
        }
        //processed create and delete changes will be removed once we confirm them in SERVER_DATA_RECEIVED
        if (change.processed && !/create|delete/.test(change.action)) {
          return false;
        }
      }
      return change;
    }).filter(Boolean);
  },

  SERVER_DATA_RECEIVED: (state, action) => {
    const existingIds = action.serverExistingElementIds;
    const remove = state.filter(({ action, type, processed, payload: { serverId } }) => {
      const exists = includes(existingIds[type], serverId);
      if (action == 'create' && processed && exists) {
        return true;
      } else if (action == 'delete' && processed && !exists) {
        return true;
      }
    }, []);
    return remove.length ? difference(state, remove) : state;
  },
});

const lastSyncTime = createReducer(0, {
  APP_LAUNCH: (state, action) => /membership\/upgraded/.test(action.location.pathname) ? 0 : state,
  SERVER_READ: (state, action) => action.full ? 0 : state,
  SERVER_DATA_RECEIVED: (state, action) => action.serverTime,
  TESTING_DELETE_ALL: () => 0,
});

const reading = createReducer(false, {
  APP_LAUNCH: () => false,
  SERVER_DATA_READING: () => true,
  SERVER_DATA_RECEIVED: () => false,
  SERVER_ERROR: () => false,
});

export const server = combineReducers({ changes, lastSyncTime, reading });
